module.exports = __webpack_public_path__ + "img/mdi_stopwatch-start.d90517fd.svg";